<template>
  <v-container>
    <v-layout text-xs-center wrap>
      <v-flex xs12>
        <div id="logo">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            :height="logoHeight"
            viewBox="0 0 800 300"
          >
            <g transform="translate(50,500) scale(0.1,-0.1)" stroke-width="15pt">
              <path
                d="M1579 4055 c-408 -117 -539 -204 -539 -355 0 -104 70 -192 345 -434
191 -168 258 -235 296 -295 40 -62 38 -92 -8 -130 -91 -75 -320 -132 -793
-195 -144 -20 -187 -29 -197 -43 -19 -26 -16 -51 10 -67 19 -13 46 -11 229 14
499 69 720 129 826 224 51 46 66 83 60 146 -9 95 -84 183 -368 432 -244 214
-300 279 -300 351 0 33 6 46 38 75 65 62 243 132 542 214 75 20 86 26 95 52 8
24 6 31 -14 47 -13 10 -26 19 -30 19 -3 -1 -90 -25 -192 -55z"
              ></path>

              <path
                d="M2128 3239 c-18 -13 -20 -34 -28 -285 -9 -294 -8 -305 43 -299 15 2
30 13 37 26 11 22 29 310 29 465 0 66 -3 81 -19 93 -25 18 -37 18 -62 0z"
              ></path>

              <path d="M2108 3389 a100,80 0 1,0 100,0z "></path>

              <path
                d="M2605 4226 c-20 -14 -20 -33 -31 -838 -7 -583 -7 -830 1 -848 8 -19
18 -25 40 -25 22 0 33 7 41 25 17 36 35 1635 20 1670 -13 30 -43 36 -71 16z"
              ></path>

              <path
                d="M5086 3727 c-21 -15 -22 -35 -7 -111 6 -33 11 -95 11 -139 l0 -79
-82 8 c-107 9 -120 8 -135 -12 -16 -22 -16 -36 0 -58 10 -14 37 -21 108 -28
52 -6 95 -12 97 -13 1 -1 -10 -80 -24 -176 -14 -96 -28 -239 -31 -319 -5 -141
-4 -146 19 -180 59 -87 140 -72 310 58 50 37 63 73 36 100 -22 22 -53 12 -128
-43 -90 -65 -128 -82 -137 -59 -16 41 38 579 60 601 4 3 45 1 92 -4 95 -10
128 -2 133 32 6 43 -19 57 -121 68 l-97 10 0 96 c-1 194 -42 293 -104 248z"
              ></path>

              <path
                d="M3390 3296 c-6 -8 -24 -73 -40 -143 -43 -198 -97 -398 -120 -450
l-22 -48 -30 59 c-16 32 -74 169 -129 305 -55 135 -108 252 -117 259 -25 19
-50 14 -67 -12 -15 -23 -11 -35 85 -272 157 -386 191 -444 259 -444 86 0 129
100 226 525 40 172 42 192 29 213 -16 25 -55 29 -74 8z"
              ></path>

              <path
                d="M3830 3193 c-114 -19 -161 -57 -168 -137 -7 -84 31 -157 187 -359 84
-108 112 -125 143 -87 10 12 18 28 18 35 0 6 -38 59 -84 117 -104 132 -157
218 -163 266 -4 33 -2 39 20 49 45 21 143 26 246 13 56 -7 101 -16 101 -20 0
-9 -38 -21 -185 -60 -44 -12 -86 -29 -92 -38 -20 -24 -16 -50 10 -67 21 -13
33 -12 132 15 209 55 264 80 285 130 17 40 -6 75 -65 101 -77 34 -292 58 -385
42z"
              ></path>

              <path
                d="M5724 3146 c-18 -13 -20 -34 -28 -285 -9 -294 -8 -305 43 -299 15 2
30 13 37 26 11 22 29 310 29 465 0 66 -3 81 -19 93 -25 18 -37 18 -62 0z"
              ></path>

              <path d="M5703 3269 a100,80 0 1,0 100,0z "></path>

              <path
                d="M4515 3101 c-64 -28 -73 -99 -30 -241 20 -65 25 -103 23 -162 -2 -86
9 -111 51 -106 58 7 70 132 27 278 -14 47 -26 98 -26 113 0 27 2 28 33 22 17
-4 74 -22 125 -41 110 -39 142 -35 142 16 0 37 -17 49 -133 89 -95 33 -180 46
-212 32z"
              ></path>

              <path
                d="M6130 3094 c-97 -33 -121 -131 -85 -354 30 -179 84 -404 102 -417 25
-19 51 -16 67 10 13 20 10 40 -25 197 -21 96 -39 178 -39 181 0 4 51 8 113 11
168 6 229 44 213 133 -19 98 -263 267 -346 239z m116 -135 c57 -36 124 -98
124 -115 0 -16 -48 -24 -151 -24 l-89 0 0 78 c0 43 3 82 7 85 15 16 62 5 109
-24z"
              ></path>
            </g>
          </svg>
        </div>
      </v-flex>

      <v-flex xs12 class="mb-2">
        <div id="who" @click="whoClick">
          <svg height="60" width="320" xmlns="http://www.w3.org/2000/svg">
            <rect class="shape" id="who-rect" :style="whoStyle" height="60" width="320"></rect>
          </svg>
          <div>Who's silvertip?</div>
        </div>
      </v-flex>

      <v-flex xs12>
        <div id="robert">
          <p>
            <span class="section">Robert Linde</span>
            <span class="section">, professional developer</span>
            <span class="section">, over 15 years in the industry.</span>
            <span class="section"> Lots of recommendations</span>
            <span class="section">, certifications</span>
            <span class="section">, awards even</span>
            <span class="section">, yada yada...</span>
          </p>

          <p>
            <span class="section"></span>
            <span class="section">Looks a bit like this:</span>
          </p>
        </div>
      </v-flex>
      <v-flex xs12>
        <div id="robert-animation">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="270" height="140">
            <g>
              <path
                id="face"
                d="m 126,31 c -4.77683,-0.385415 -9.34696,1.989324 -13,3.37 -0.46548,1.042988 -1.05798,0.949 
                    -2.01,1.42 -3.05005,3.183975 -6.97116,3.473785 -10.43,6.64 l -0.47,0.47 c -0.335269,1.182769 -2.231791,1.146461 
                    -2.85,2.37 l -0.47,0.47 c -0.7071,1.505052 -1.63277,2.779854 -2.37,4.27 -0.723365,0.800175 -1.008979,2.01843 -1.42,2.84 
                    -1.902826,2.542387 -1.421762,4.763279 -2.85,7.59 v 0.47 c -1.044627,2.529136 -1.445743,5.848579 -1.42,8.53 v 1.42 
                    c 0.362644,1.816533 1.42,4.157242 1.42,6.16 v 0.95 c -0.07307,1.20317 0.178689,2.452062 0.95,3.32 v 0.47 c -0.02205,8.45932 
                    4.055821,10.053266 8.06,13.75 1.0759,0.128041 1.48273,0.683843 2.37,0.94 3.91442,3.012557 9.08709,2.200562 13.27,4.27 
                    1.60387,0.97854 3.34349,1.41004 4.26,1.42 6.08168,4.35892 16.23091,-0.88955 22.75,2.37 0.44654,0.55697 0.74115,0.48 1.43,0.48 
                    h 4.73 c 1.17651,0 2.20958,0 3.32,0 5.41023,0.92782 10.97373,-0.95 16.12,-0.95 0.47333,0 0.94667,0 1.42,0 3.4767,-0.60448 
                    9.27501,-1.22501 12.32,-4.27 0.74319,-0.434622 1.55984,-0.676144 2.37,-0.95 2.63848,-2.687596 7.11,-5.483473 7.11,-9.47 
                    0.69437,-3.70618 1.87178,-7.489611 1.89,-10.9 0,-3.73211 0,-7.785754 0,-11.38 -1.31996,-3.024357 -1.28799,-6.27906 -2.37,-9.48 
                    0.0459,-1.469582 -0.28999,-2.959986 -0.94,-4.26 l -0.48,-0.48 c -0.46155,-2.789414 -2.0181,-5.466193 -3.31,-8.05 
                    l -0.48,-0.95 -0.47,-0.95 v -0.95 c -1.33395,-1.709695 -2.03738,-2.739182 -3.32,-3.79 h -0.47 v -0.47 c -1.58206,-0.714668 
                    -2.84237,-1.894895 -4.27,-2.85 l -1.42,-0.47 h -0.47 l -0.95,-0.95 h -1.42 l -0.95,-0.47 c -2.76507,-1.155858 -5.43378,-2.490714 
                    -8.06,-3.79 h -0.47 -0.48 c -2.03713,-0.353671 -4.15973,-0.910392 -6.16,-1.9 l -0.95,-0.47 h -1.42 -0.47 c -3.84779,-0.424457 
                    -8.16803,0.268679 -11.85,-0.95 -1.80482,0.04548 -3.49626,0.09929 -5.21,-0.48 h -1.9 -4.26 -5.69 -0.48 c -1.90004,0.418716 
                    -3.7945,1.43 -5.68,1.43 -0.52976,-0.06145 -0.56622,0.155581 -0.95,0.47 -1.78276,1.0606 -2.9868,1.871948 -4.27,3.79 l -0.94,0.48 
                    c -1.37022,1.864492 -3.25248,2.086709 -4.74,3.31"
              ></path>

              <path
                id="mouth"
                d="M108.62,81.29 
                                            109.09,81.76 110.04,82.71 110.99,83.18 
                                            112.41,84.61 113.36,85.55 114.31,86.03 
                                            115.73,87.45 116.68,87.92 118.10,88.87 
                                            118.57,88.87 119.04,89.82 119.99,89.82 
                                            120.47,90.29 120.94,90.29 121.89,91.24 
                                            122.36,91.24 122.84,91.24 123.31,91.72 
                                            123.31,92.19 124.26,92.19 124.73,92.66 
                                            125.21,92.66 125.68,93.14 126.63,93.61 
                                            127.58,93.61 128.05,94.09 128.52,94.09 
                                            129.00,94.09 129.95,94.56 130.42,94.56 
                                            131.37,94.56 132.79,95.03 133.74,95.03 
                                            135.16,95.51 136.11,95.51 137.53,95.51 
                                            139.90,95.51 141.32,95.51 143.69,95.51 
                                            145.11,95.51 146.53,95.51 147.95,95.51 
                                            148.90,95.51 149.38,95.51 149.85,95.51 
                                            150.32,95.51 151.27,95.51 151.75,95.03 
                                            152.69,95.03 153.64,95.03 154.59,95.03 
                                            155.54,94.56 156.96,93.61 158.86,93.14 
                                            159.80,92.66 160.28,92.19 161.70,92.19 
                                            162.17,91.24 162.65,90.77 163.12,90.77 
                                            163.59,90.77 164.07,90.29 164.54,90.29 
                                            165.02,89.82 165.96,88.87 166.44,88.40 
                                            167.39,87.92 169.28,85.55 169.76,85.08 
                                            169.76,84.61 170.23,84.61 170.23,84.13 
                                            170.70,84.13 170.70,83.66 "
              ></path>

              <path
                id="left-eye"
                d="M117.62,46.69 113.36,46.69 112.88,47.17 111.46,47.17 
                                            109.57,47.64 109.57,48.11 109.09,48.11 108.62,48.59 
                                            108.14,49.06 108.14,49.54 108.14,50.01 108.14,50.48 
                                            108.14,50.96 108.14,51.43 108.14,51.90 108.14,52.38 
                                            108.62,52.38 109.09,52.85 109.09,53.80 109.09,54.27 
                                            110.04,54.75 110.04,55.22 110.04,55.70 110.51,55.70 
                                            110.51,56.17 110.51,56.64 110.99,56.64 111.46,56.64 
                                            111.94,56.64 112.41,56.64 112.88,56.64 113.83,56.64 
                                            114.78,56.64 115.25,56.17 115.73,55.70 116.68,55.70 
                                            117.15,55.22 117.62,55.22 118.10,55.22 118.57,55.22 
                                            118.57,54.75 119.04,54.75 119.04,54.27 119.52,54.27 
                                            119.52,53.80 119.99,53.80 119.99,53.33 119.99,52.85 
                                            119.99,52.38 119.99,51.90 119.99,51.43 119.99,50.48 
                                            119.99,50.01 119.52,49.06 119.04,48.59 118.57,48.59 
                                            118.10,48.59 117.62,48.59 117.62,48.11 117.15,47.64"
              >
                <animate
                  id="left-blink"
                  begin="indefinite"
                  attributeName="d"
                  attributeType="XML"
                  dur=".5s"
                  fill="freeze"
                  from="M117.62,46.69 113.36,46.69 112.88,47.17 111.46,47.17 
                                            109.57,47.64 109.57,48.11 109.09,48.11 108.62,48.59 
                                            108.14,49.06 108.14,49.54 108.14,50.01 108.14,50.48 
                                            108.14,50.96 108.14,51.43 108.14,51.90 108.14,52.38 
                                            108.62,52.38 109.09,52.85 109.09,53.80 109.09,54.27 
                                            110.04,54.75 110.04,55.22 110.04,55.70 110.51,55.70 
                                            110.51,56.17 110.51,56.64 110.99,56.64 111.46,56.64 
                                            111.94,56.64 112.41,56.64 112.88,56.64 113.83,56.64 
                                            114.78,56.64 115.25,56.17 115.73,55.70 116.68,55.70 
                                            117.15,55.22 117.62,55.22 118.10,55.22 118.57,55.22 
                                            118.57,54.75 119.04,54.75 119.04,54.27 119.52,54.27 
                                            119.52,53.80 119.99,53.80 119.99,53.33 119.99,52.85 
                                            119.99,52.38 119.99,51.90 119.99,51.43 119.99,50.48 
                                            119.99,50.01 119.52,49.06 119.04,48.59 118.57,48.59 
                                            118.10,48.59 117.62,48.59 117.62,48.11 117.15,47.64"
                  to="M117.62,56.69 113.36,56.69 112.88,55.17 111.46,55.17 
                                            109.57,55.64 109.57,54.11 109.09,54.11 108.62,54.59 
                                            108.14,53.06 108.14,53.54 108.14,53.01 108.14,53.48 
                                            108.14,53.96 108.14,51.43 108.14,51.90 108.14,52.38 
                                            108.62,52.38 109.09,52.85 109.09,53.80 109.09,54.27 
                                            110.04,54.75 110.04,55.22 110.04,55.70 110.51,55.70 
                                            110.51,56.17 110.51,56.64 110.99,56.64 111.46,56.64 
                                            111.94,56.64 112.41,56.64 112.88,56.64 113.83,56.64 
                                            114.78,56.64 115.25,56.17 115.73,55.70 116.68,55.70 
                                            117.15,55.22 117.62,55.22 118.10,55.22 118.57,55.22 
                                            118.57,54.75 119.04,54.75 119.04,54.27 119.52,54.27 
                                            119.52,53.80 119.99,53.80 119.99,53.33 119.99,52.85 
                                            119.99,52.38 119.99,51.90 119.99,51.43 119.99,50.48 
                                            119.99,50.01 119.52,53.06 119.04,54.59 118.57,54.59 
                                            118.10,54.59 117.62,54.59 117.62,54.11 117.15,55.64"
                ></animate>
              </path>

              <path
                id="right-eye"
                d="M163.12,47.64 
                                            162.65,47.64 162.17,47.64 161.70,47.64 161.22,47.64 
                                            160.75,47.64 160.28,47.64 159.80,47.64 159.33,47.64 
                                            158.86,47.64 157.91,48.11 157.43,48.11 157.43,48.59 
                                            157.43,49.54 157.43,50.01 157.43,50.48 157.43,50.96 
                                            157.43,51.43 157.43,51.90 157.43,52.38 157.43,52.85 
                                            157.43,53.33 157.43,53.80 157.43,54.27 157.91,54.27 
                                            158.38,54.27 158.38,54.75 158.86,55.22 159.33,55.22 
                                            159.33,55.70 159.80,55.70 160.28,55.70 160.75,55.70 
                                            161.22,55.70 161.70,55.70 162.17,55.70 162.65,55.70 
                                            163.12,55.70 163.59,55.70 164.07,55.70 164.54,55.70 
                                            165.02,55.70 165.02,55.22 165.49,55.22 165.49,54.75 
                                            165.49,54.27 165.49,53.80 165.49,53.33 165.49,52.85 
                                            165.49,52.38 165.49,51.90 165.49,51.43 165.49,50.96 
                                            165.49,50.48 165.49,50.01 165.49,49.54 165.49,49.06 
                                            165.49,48.59 165.02,48.59 165.02,48.11 164.54,48.11 
                                            164.54,47.64 164.07,47.64 163.59,47.64 163.12,47.64 
                                            162.65,47.64 162.17,47.17 161.70,47.17 "
              ></path>

              <path
                id="left-foot"
                d="M112.88,100.25 112.88,100.72 112.88,101.19 113.36,102.14 
                                            113.36,103.09 113.36,104.04 113.36,104.51 113.36,104.99 
                                            113.36,105.46 113.36,105.93 113.36,106.41 113.36,107.36 
                                            113.36,107.83 113.36,108.78 113.36,110.20 113.36,111.62 
                                            112.88,113.99 112.41,115.41 111.94,116.83 111.46,118.73 111.46,120.15 
                                            111.46,122.05 110.99,123.47 110.51,123.94 110.51,124.42 
                                            110.51,124.89 110.51,125.36 110.51,125.84 110.51,126.31 
                                            110.51,126.79 110.04,126.79 108.62,126.79 106.72,126.79 
                                            104.83,126.79 102.46,126.79 101.04,126.79 98.19,126.79 
                                            94.87,126.79 93.45,126.79 91.56,126.79 88.71,126.79 
                                            87.77,126.79 86.82,126.79 86.34,126.79 "
              ></path>

              <path
                id="right-foot"
                d="M164.07,104.51 164.07,104.99 
                        164.07,105.93 164.54,106.88 164.54,107.83 164.54,109.25 
                        164.54,110.67 164.54,112.09 164.54,113.04 164.54,113.99 
                        164.54,114.94 164.54,115.41 164.54,116.36 164.54,116.83 
                        164.54,117.78 164.54,118.73 164.54,119.20 164.07,119.68 
                        164.07,120.15 163.59,121.57 163.59,122.52 163.12,123.00 
                        163.12,123.94 162.65,125.36 162.17,125.36 162.17,125.84 
                        162.17,126.31 162.17,126.79 162.17,127.26 161.70,127.73 
                        162.17,127.73 163.12,127.73 164.07,127.73 165.49,127.73 
                        167.39,127.73 170.70,127.73 174.02,127.73 177.81,127.73 
                        181.60,127.73 183.97,127.73 186.82,127.73 188.71,127.73 
                        191.08,128.68 192.50,128.68 193.93,128.68 194.40,128.68 
                        194.87,129.16 "
                style="color: rgb(0, 0, 0);"
                class
              ></path>

              <path
                id="right-arm"
                d="M192.98,72.28 193.45,72.28 
                        193.93,71.34 195.82,70.86 196.77,70.39 198.19,69.91 200.09,68.97
                         201.51,68.49 202.93,67.54 204.35,66.60 
                         205.77,65.18 207.20,64.23 208.14,62.81 209.57,61.86 
                         210.04,61.38 210.99,60.44 211.46,59.49 211.94,59.01 
                         212.41,58.54 212.88,57.59 213.36,57.12 213.36,56.64 
                         213.83,56.17 213.83,55.70 214.31,55.70 214.31,55.22 
                         214.31,54.75 214.78,54.75 215.25,54.75 215.25,53.80 
                         215.73,53.80 215.73,53.33 216.20,53.33 216.20,52.85 
                         216.68,52.85 216.68,52.38 217.15,51.90 217.62,50.96 
                         217.62,50.48 218.10,50.48 218.10,50.01 218.57,49.54 
                         218.57,49.06 218.57,48.59 219.04,48.59 219.52,48.11 
                         219.52,47.64 219.99,47.17 219.99,46.69 220.47,46.69 "
              ></path>

              <path
                id="right-hand"
                d="M219.99,46.69 219.04,46.69 
                        218.57,46.22 218.10,45.74 218.10,45.27 217.15,44.80 
                        217.15,44.32 217.15,43.85 217.15,43.37 216.68,42.43 
                        216.68,41.95 216.68,41.48 216.68,40.53 216.68,40.06 
                        216.68,39.58 217.15,39.58 217.62,38.16 218.10,38.16 
                        218.57,37.21 219.04,36.74 219.52,36.74 219.99,36.27 
                        220.47,35.79 220.94,35.32 221.41,35.32 221.89,34.84 
                        222.36,34.84 222.84,34.37 223.31,34.37 223.31,33.90 
                        223.78,33.90 224.26,33.90 224.26,34.37 224.26,35.32 
                        224.26,35.79 224.26,37.21 224.26,37.69 223.78,38.16 
                        223.78,39.58 222.84,40.06 222.36,41.00 222.36,41.48 
                        221.89,41.95 221.89,42.43 221.89,41.95 222.36,41.95 
                        222.84,41.95 223.31,41.48 223.78,41.48 224.26,41.48 
                        224.73,41.00 225.21,40.53 225.68,40.53 226.15,40.53 
                        226.15,40.06 226.63,40.06 227.58,40.06 228.05,39.58 
                        228.52,39.11 229.00,39.11 229.47,39.11 229.47,38.63 
                        229.95,38.63 230.42,38.63 230.89,38.63 230.89,39.11 
                        230.89,39.58 230.89,40.06 229.95,40.06 229.95,40.53 
                        229.47,41.00 229.00,41.48 228.52,41.48 228.52,41.95 
                        228.05,41.95 228.05,42.43 227.58,42.43 227.10,42.43 
                        226.63,42.43 226.63,42.90 228.05,42.90 229.00,42.90 
                        229.95,41.95 231.37,41.95 232.31,41.48 232.79,41.48 
                        233.26,41.48 233.74,41.48 234.21,41.48 234.68,41.48 
                        235.16,41.48 235.63,41.48 236.11,41.95 236.11,42.43 
                        236.11,42.90 236.11,43.37 236.11,43.85 236.11,44.32 
                        235.63,44.80 235.63,45.27 235.16,45.27 234.68,45.74 
                        234.21,46.22 233.26,46.69 232.31,46.69 232.31,47.17 
                        231.84,47.17 231.37,47.17 230.89,47.17 230.42,47.17 
                        230.89,47.17 231.84,47.17 232.79,47.17 233.26,47.17 
                        234.21,46.69 234.68,46.69 235.16,46.69 235.63,46.69 
                        236.11,46.69 236.58,46.69 236.58,47.17 236.58,47.64 
                        236.58,48.11 236.58,48.59 236.11,48.59 235.63,48.59 235.16,48.59 
                        234.68,48.59 234.21,49.06 233.74,49.06 233.26,49.06 
                        232.79,49.06 232.31,49.06 231.84,49.06 231.37,49.06 
                        230.42,49.06 229.95,49.06 229.47,49.06 228.52,49.06 
                        228.05,49.06 227.58,49.06 227.10,49.06 226.63,49.06 
                        226.15,49.06 225.68,49.06 225.21,49.06 224.73,49.06 
                        224.26,49.06 223.78,49.06 223.31,49.06 222.84,49.06 
                        222.36,49.06 221.89,49.06 221.41,49.06 220.94,49.06 
                        220.47,49.06 219.99,49.06 219.52,49.06"
              >
                <animateTransform
                  attributeType="xml"
                  begin="indefinite"
                  id="right-wave"
                  attributeName="transform"
                  type="rotate"
                  from="0 226.6 41.5"
                  to="0 226.6 41.5"
                  values="0 226.6 41.5; -8 226.6 45.5; 4 226.6 50.5; -8 226.6 45.5; 4 226.6 41.5; 0 226.6 41.5"
                  dur="1.5s"
                  repeatCount="indefinite"
                ></animateTransform>
              </path>

              <path
                id="left-arm"
                d="M88.24,64.70 87.77,64.70 
                        87.29,64.70 86.82,64.70 86.34,64.70 85.40,64.70 84.92,64.70 
                        84.45,64.70 83.50,65.18 82.55,65.18 82.08,65.65 81.13,66.12 
                        80.18,66.12 80.18,67.07 79.23,67.54 78.76,68.02 78.29,68.02 
                        78.29,68.97 77.81,68.97 77.34,69.91 77.34,70.39 76.39,70.86 
                        76.39,71.34 75.92,71.81 75.44,72.28 75.44,72.76 74.97,73.23 
                        74.50,74.65 74.02,75.13 73.55,75.60 73.07,76.55 72.60,76.55 
                        72.60,77.50 71.65,78.45 71.18,79.39 70.70,80.81 70.23,81.29 
                        70.23,82.24 69.76,82.71 69.28,83.66 69.28,84.13 69.28,84.61 
                        68.81,85.08 67.39,87.45 67.39,87.92 67.39,88.40 67.39,88.87 
                        66.91,89.35 66.91,89.82 66.91,90.29 66.91,90.77 66.91,91.24 
                        66.91,91.72 66.44,92.19 66.44,92.66 65.96,92.66 65.96,93.14 
                        65.96,93.61 "
              ></path>

              <path
                id="left-hand"
                d="M65.49,93.14 64.54,93.14 
                        59.80,94.56 58.86,95.03 58.38,95.03 57.91,95.51 57.43,95.51 
                        56.96,96.45 56.49,96.45 56.01,96.93 55.54,97.40 55.54,97.88 
                        55.54,98.35 55.54,98.82 56.01,98.82 56.01,99.30 56.49,99.30 
                        56.96,99.30 57.43,99.30 57.91,99.30 58.38,98.82 58.86,98.35 
                        59.33,98.35 60.28,98.35 60.75,98.35 60.75,97.88 61.22,97.88 
                        61.70,97.40 62.17,96.93 62.17,96.45 62.65,96.45 63.12,95.98 
                        63.59,95.98 63.59,95.51 64.07,95.51 64.07,95.03 64.54,95.03 
                        64.54,94.56 65.02,94.56 65.49,94.56 65.02,94.56 64.54,95.03 
                        63.59,95.98 62.65,96.45 62.17,97.40 61.22,97.88 60.28,98.35 
                        59.80,98.82 59.33,99.30 59.33,99.77 58.86,99.77 58.86,100.25 
                        58.38,101.19 57.91,101.67 57.43,102.62 57.43,103.09 
                        56.49,104.51 56.01,105.46 55.54,106.88 55.54,107.36 
                        56.49,107.36 56.96,107.36 57.43,106.88 58.38,105.93 
                        59.33,104.99 60.28,104.51 61.22,103.56 61.70,103.56 
                        62.65,102.62 63.12,101.67 63.12,101.19 63.59,100.72 
                        64.07,100.25 64.07,99.30 64.07,98.82 64.07,98.35 
                        64.07,98.82 63.59,99.77 63.59,100.25 62.65,101.19 
                        62.17,102.14 61.70,103.09 61.22,104.04 61.22,104.51
                         60.28,105.46 59.80,105.93 59.80,106.41 60.28,105.93 
                         60.75,105.46 61.22,104.99 61.22,104.51 61.22,104.99 
                         61.22,105.46 61.22,105.93 61.70,106.41 61.70,106.88 
                         62.17,106.88 62.17,107.36 62.65,107.83 63.12,107.83 
                         63.59,106.88 64.54,105.46 64.54,104.04 65.02,103.09 
                         65.02,102.14 65.49,101.67 65.49,101.19 65.49,101.67 
                         65.49,102.14 65.49,102.62 65.49,103.56 65.49,104.51 
                         65.49,104.99 65.49,105.46 65.49,105.93 65.96,105.93 
                         66.44,105.46 66.91,104.99 66.91,103.56 67.39,102.62 
                         67.86,102.14 67.86,101.67 67.86,101.19 67.86,100.25 
                         68.33,99.30 68.33,98.82 68.33,98.35 68.33,97.88 
                         68.33,97.40 68.33,96.93 68.33,96.45 68.33,95.98 
                         67.86,95.98 67.86,95.51 67.86,95.03 67.86,94.56 
                         67.86,94.09 67.39,94.09 67.39,93.61 66.44,93.61 
                         65.96,93.61 66.91,93.61 "
              ></path>
            </g>
          </svg>
        </div>
      </v-flex>
      <v-flex xs12>
        <div id="links" :class="{show: showLinks}">
          <p class="headline">Find me online:</p>
          <div>
            <v-btn href="https://twitter.com/svalgrodnad" target="_blank">Twitter</v-btn> 
            <v-btn href="https://github.com/Roblinde" target="_blank">Github</v-btn>
            <v-btn href="https://robertlinde.se" target="_blank">Blog</v-btn>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Main",
  methods: {
    whoClick() {
      this.whoStyle = {
        fill: "ffb6cc",
        fillOpacity: 0.6
      };
      var that = this;
      setTimeout(function() {
        that.whoStyle = {
          fill: "",
          fillOpacity: 0
        };
      }, 100);
      this.startStory();
    },
    startStory() {
      if (this.storyStarted) return;

      this.storyStarted = true;

      const sections = document.getElementsByClassName("section");
      const base = 300;
      const between = 300;
      let that = this;
      for (var i = 0; i < sections.length; i++) {
        let section = sections[i];
        let index = i;
        setTimeout(function() {
          section.className = "section active";
          if (index == sections.length - 1) {
            setTimeout(that.startDrawing, between);
          }
        }, i * between + base);
      }
    },
    startDrawing() {
      document.getElementById("face").classList.add("animate");
      document.getElementById("mouth").classList.add("animate");
      document.getElementById("left-eye").classList.add("animate");
      document.getElementById("right-eye").classList.add("animate");
      document.getElementById("right-foot").classList.add("animate");
      document.getElementById("left-foot").classList.add("animate");
      document.getElementById("right-arm").classList.add("animate");
      document.getElementById("right-hand").classList.add("animate");
      document.getElementById("left-arm").classList.add("animate");
      document.getElementById("left-hand").classList.add("animate");
      setTimeout(this.hookAnimations, 6000);
    },
    hookAnimations() {
      setTimeout(() => { this.showLinks = true }, 1000)
      setInterval(this.blinkLeftEye, 4000);
      this.waveRightHand(true);
    },
    waveRightHand(start) {
      const rightwave = document.getElementById("right-wave");
      let that = this;
      if (start) {
        rightwave.beginElement();
        setTimeout(function() {
          that.waveRightHand(false);
        }, 3000);
      } else {
        rightwave.endElement();
        setTimeout(function() {
          that.waveRightHand(true);
        }, 5000);
      }
    },
    blinkLeftEye() {
      const leftBlink = document.getElementById("left-blink");
      const from = leftBlink.getAttribute("from");
      let that = this;

      if (from.indexOf("M117.62,56.69") == 0) {
        that.switchToAndFrom(leftBlink);
      }

      leftBlink.beginElement();
      setTimeout(function() {
        that.switchToAndFrom(leftBlink);
        leftBlink.beginElement();
      }, 550);
    },
    switchToAndFrom(elem) {
      var oldTo = elem.getAttribute("to");
      var oldFrom = elem.getAttribute("from");
      elem.setAttribute("to", oldFrom);
      elem.setAttribute("from", oldTo);
    }
  },
  computed: {
    logoHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "100pt";
        case "sm":
          return "150pt";
        case "md":
          return "200pt";
        case "lg":
          return "300pt";
        case "xl":
          return "300pt";
      }
    }
  },
  data() {
    return {
      storyStarted: false,
      showLinks: false,
      whoStyle: {
        fill: "",
        fillOpacity: 1
      }
    };
  }
};
</script>
